import React from "react";
import AppTheme from "../../../../service/app_config/AppTheme";
import { IconNormal } from "../../../../widget/common/ui/Icon";
import { BranchFollowGroupsContextImport } from "../../../../provider/branch/branch_follow_groups/BranchFollowGroupsContextProvider";

const BranchFollowGroupsActions = () => {
  const { showSearch, updateShowSearch } = BranchFollowGroupsContextImport();

  return (
    <>
      {!showSearch && (
        <IconNormal
          name="magnify"
          color={AppTheme.themeFont}
          handleClick={() => updateShowSearch()}
        />
      )}
    </>
  );
};

export default BranchFollowGroupsActions;
